<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels"
    import type { ValidationError } from "@common/types"

    /* props */

    const props = defineProps<{
        propF: AlternativeEditorAttributeFieldReadModel
        propErrors: ValidationError[]
    }>()

    /* aliases */

    const f = toRef(props, 'propF')
    const errors = toRef(props, 'propErrors')

    /* derived */

    const error = computed(() =>
        errors.value.find(e =>
            e.Context.startsWith(`AlternativeAttribute:${f.value.Id}`)
        )?.Error
    )
</script>

<template>
    <div class="form-group">
        <label>
            <span v-if="f.IsRequired" style="color: red;">*</span> {{ f.Name }}
        </label>

        <select v-model="f.Values"
                class="form-control"
                multiple
                :required="f.IsRequired"
                :disabled="f.IsReadonly">
            <option v-for="dv in f.DefinedValues"
                    :key="dv.Value"
                    :value="dv.Value">
                {{ dv.Label }}
            </option>
        </select>

        <div class="error">{{ error }}</div>

        <small v-if="f.Description" class="form-text text-muted">
            {{ f.Description }}
        </small>
    </div>
</template>
